import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useThemeMode } from '../../ThemeContext';
import { dataAPI } from '../../helpers/api_service';
import { APP_URLS } from '../../helpers/url_helper';
import TemplateLibraryTable from './components/TemplateLibraryTable';
import TemplatePreview from './components/TemplatePreview';

function DigitalFormManagement() {
  const { mode } = useThemeMode();
  const navigate = useNavigate();
  const [templates, setTemplates] = useState([]);
  const [previewTemplate, setPreviewTemplate] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadTemplates = async () => {
      try {
        setIsLoading(true);
        setError('');
        const response = await dataAPI.getDigitalFormTemplates({
          showLoading: false,
        });

        if (response?.status === 'success') {
          const apiTemplates = Array.isArray(response.data) ? response.data : [];
          setTemplates(apiTemplates);
        } else {
          setTemplates([]);
          setError('Failed to load template list.');
        }
      } catch (err) {
        setTemplates([]);
        setError(err?.message || 'Failed to load template list.');
      } finally {
        setIsLoading(false);
      }
    };

    loadTemplates();
  }, []);

  const handleCreateFromTemplate = (template) => {
    navigate(APP_URLS.DIGITAL_FORM_USE_TEMPLATE, {
      state: { template },
    });
  };

  return (
    <div style={{ padding: '24px 28px' }}>
      {previewTemplate && (
        <TemplatePreview
          mode={mode}
          template={previewTemplate}
          onBack={() => setPreviewTemplate(null)}
          onUseTemplate={handleCreateFromTemplate}
        />
      )}

      {!previewTemplate && (
        <>
          {isLoading && (
            <div style={{ color: mode === 'dark' ? '#d5d5d5' : '#444', fontSize: 14 }}>
              Loading templates...
            </div>
          )}

          {!isLoading && error && (
            <div
              style={{
                border: `1px solid ${mode === 'dark' ? '#704040' : '#f1b2b2'}`,
                background: mode === 'dark' ? '#2b1717' : '#fff3f3',
                color: mode === 'dark' ? '#ffb0b0' : '#a53030',
                borderRadius: 8,
                padding: '12px 14px',
                fontSize: 14,
              }}
            >
              {error}
            </div>
          )}

          {!isLoading && !error && templates.length === 0 && (
            <div
              style={{
                border: `1px solid ${mode === 'dark' ? '#3e3e3e' : '#e3e6e9'}`,
                background: mode === 'dark' ? '#1a1a1a' : '#fff',
                color: mode === 'dark' ? '#d5d5d5' : '#555',
                borderRadius: 10,
                padding: '16px',
              }}
            >
              No templates available yet.
            </div>
          )}

          {!isLoading && !error && templates.length > 0 && (
            <TemplateLibraryTable
              mode={mode}
              templates={templates}
              onPreview={setPreviewTemplate}
              onUseTemplate={handleCreateFromTemplate}
            />
          )}
        </>
      )}
    </div>
  );
}

export default DigitalFormManagement;
